import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
import '../../public/css/new-app.css'
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import SkillCard from "components/Frontend/SkillCard";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import FeatureSection from "components/PublicPagesReusable/FeatureSection";
import QRCode from "react-qr-code";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import Complement from "../assets/images/public-pages/complement.svg";
import Essential from "../assets/images/public-pages/essential.svg";
import Professional from "../assets/images/public-pages/professional.svg";
import Commuters from "../assets/images/public-pages/commuters.svg";
import Seamless from "../assets/images/public-pages/seamless-integrate.svg";
import Smart from "../assets/images/public-pages/smart-progress.svg";
import Regular from "../assets/images/public-pages/Regular-update.svg";
import Expert from "../assets/images/public-pages/Expert-designed.svg";


const openExternalUrl = (url) => {
  if (!url) {
    console.warn("openExternalUrl: URL is empty or undefined");
    return;
  }
  try {
    new URL(url);
  } catch {
    console.warn("openExternalUrl: invalid URL:", url);
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
};

const NaatiAppNew = () => {
  const navigate = useNavigate();
  const validator = useRef(new SimpleReactValidator());
  const sliderRef = useRef(null);

  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    error: [],
    submit: false,
    flag: false,
    lockSubmit: false,
    homePage: false,
    list: [],
    sliderStyles: { marginLeft: "0px", width: "100%" },
  });

  const adjustSliderWidth = useCallback(() => {
    const container = document.querySelector(".container");
    const outerDiv = document.querySelector(".outer-wrapper");
    const slickList = document.querySelector(".slick-list");
    if (container && outerDiv && slickList) {
      const leftWidth = container.getBoundingClientRect().left;
      const rightWidth =
        outerDiv.getBoundingClientRect().right - window.innerWidth;
      setState((prev) => ({
        ...prev,
        sliderStyles: {
          marginLeft: `${leftWidth}px`,
          width: `calc(100vw - ${leftWidth}px + ${Math.abs(rightWidth)}px)`,
        },
      }));
    }
  }, []);

  useEffect(() => {
    adjustSliderWidth();
    window.addEventListener("resize", adjustSliderWidth);

    // Analytics and pixel initialization
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();

    return () => {
      window.removeEventListener("resize", adjustSliderWidth);
    };
  }, [adjustSliderWidth]);

   const pteSlider = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
    ],
  };

  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
  };

  const bannerTitle = () => (
    <h1 className="top-section-text FS56FW500 mb-4">
      Master <span className="text-success fw-600">NAATI CCL</span> From<br />
      Anywhere With Best NAATI CCL<br />
      Exam Practice App
    </h1>
  );

  const downloadSection = () => (
      <div className="download-buttons d-flex flex-wrap justify-content-center justify-content-lg-start gap-3">
        <button type="button" className="downlaod-btn" aria-label="Download on the App Store"
        onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)}
        style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}>
          <img
            src="/images/web-new-images/app-store-01.svg"
            alt="Download on the App Store"
          />
        </button>
        <button type="button" className="downlaod-btn" aria-label="Get it on Google Play"
        onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_ANDROID_APP_URL)}
         style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}>
          <img
            src="/images/web-new-images/google-play-01.svg"
            alt="Get it on Google Play"
          />
        </button>
      </div>
    );
  

  const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: bannerTitle,
    subtitle: "The complete mobile solution that ensures your language proficiency goals are always within reach, wherever life takes you.",
    // btn_prepration: { text: "Begin NAATI CCL Training", onClick: () => window.location.href = `${import.meta.env.VITE_NAATI_URL}auth/register` },
    // btn_outline: { text: "Free Mock Test", variant: "outline", onClick: () => window.location.href = '/auth/register' },
    appDownloadBtn: downloadSection,
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/Pritam.svg",
      "/images/web-new-images/new-content-slider/Karthik-B.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students'",
    profile: {
      image: "/images/web-new-images/emojis/Updated/new-PTE-mobile.webp",
      imageSize: '1.2',
      topSpacing: '-15%'
    }
  };

  const academySections = [
    {
      title: (
        <>
          NAATI CCL Comprehensive <br /> Vocabulary Mastery
        </>
      ),
      highlight: "2,000+ Essential Words in 7 Strategic Categories",
      features: [
        "Complete vocabulary lists translated into all 12 supported languages",
        "Context-based learning with real exam scenarios",
        "Cultural nuances and terminology specific to NAATI CCL requirements",
      ],
      iconBg: "#F4EBFF",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Completevocabulary.png'
    },
    {
      title: (
        <>
          Realistic Practice Dialogues & Audio
        </>
      ),
      highlight: "80+ Expert-Crafted Dialogue Sessions",
      features: [
        "Practice scenarios inspired by previous actual exams",
        "Sample responses prepared by certified NAATI interpreters",
        "Varied difficulty levels to match your preparation stage",
      ],
      iconBg: "#0286FF1F",
      icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" rx="32" fill="#48A75C"/>
      <path d="M42.6654 32V33.3333C42.6654 39.2244 37.8897 44 31.9987 44C26.1077 44 21.332 39.2244 21.332 33.3333V32M31.9987 38.6667C29.0532 38.6667 26.6654 36.2789 26.6654 33.3333V25.3333C26.6654 22.3878 29.0532 20 31.9987 20C34.9442 20 37.332 22.3878 37.332 25.3333V33.3333C37.332 36.2789 34.9442 38.6667 31.9987 38.6667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/AppSuccess.png'
    },
    {
      title: (
        <>
          Real-Time Exam Simulation
        </>
      ),
      highlight: "Mock Tests That Mirror the Actual Experience",
      features: [
        "30-minute timed practice sessions just like the real exam",
        "Two 300-word dialogues with authentic audio quality",
        "Instant scoring and detailed performance analysis",
      ],
      iconBg: "#FFB02C1F",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Instantscoring.png'
    },
    {
      title: (
        <>
          Proven Success Strategies
        </>
      ),
      highlight: "Expert Tips for First-Attempt Success",
      features: [
        "Time management techniques under pressure",
        "Cultural sensitivity training for accurate interpretation",
        "Last-minute preparation packages for exam day confidence",
      ],
      iconBg: "#94C23C1F",
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="32" fill="#48A75C"/>
        <path d="M42.6654 32V33.3333C42.6654 39.2244 37.8897 44 31.9987 44C26.1077 44 21.332 39.2244 21.332 33.3333V32M31.9987 38.6667C29.0532 38.6667 26.6654 36.2789 26.6654 33.3333V25.3333C26.6654 22.3878 29.0532 20 31.9987 20C34.9442 20 37.332 22.3878 37.332 25.3333V33.3333C37.332 36.2789 34.9442 38.6667 31.9987 38.6667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/AppSuccess.png'
    },
    {
      title: (
        <>
          Seamless Mobile Experience
        </>
      ),
      highlight: "Study Anywhere, Anytime with Zero Compromise",
      features: [
        "Offline access to all vocabulary and practice materials",
        "Progress tracking across all devices",
        "Never miss a learning opportunity again",
      ],
      iconBg: "#FFB02C1F",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/AppSuccess.png'
    },
  ];

  const lifestyleCards = [
    {
      title: "Perfect For Commuters",
      text: "Transform your daily travel time into productive exam preparation. Practice NAATI CCL vocabulary or review dialogues and templates while waiting.",
      color: "rgba(255, 255, 255, 0)",
      img: Commuters
    },
    {
      title: "Ideal For Working Professionals",
      text: "Squeeze in focused practice sessions during lunch breaks, before meetings, or whenever you have 10-15 spare minutes.NAATI CCL based on your priorities.",
      color: "rgba(255, 255, 255, 0)",
      img: Professional
    },
    {
      title: "Essential For Students'",
      text: "Balance your exam preparation with university commitments. Study efficiently for both NAATI CCL without compromising your academic schedule.",
      color: "rgba(255, 255, 255, 0)",
      img: Essential
    },
    {
      title: "Complement To Classroom Learning",
      text: "Never fall behind even if you miss in-person classes. Access the same quality materials and exercises for both exams from anywhere.",
      color: 'rgba(255, 255, 255, 0)',
      img: Complement
    },
  ];
  const images = [
  {
    src: "/images/web-new-images/emojis/Updated/Score01.png",
    alt: "score-1",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score02.png",
    alt: "score-2",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score03.png",
    alt: "score-3",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score04.png",
    alt: "score-4",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score05.png",
    alt: "score-5",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score06.png",
    alt: "score-6",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score07.jpg",
    alt: "score-7",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score08.jpg",
    alt: "score-8",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score09.jpg",
    alt: "score-9",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score10.jpg",
    alt: "score-10",
  },
];

const skillAreaTitle = () => {
    return (
   <h3 className="top-section-text FS56FW500 mb-4 white">
    Designed For Your <span className="text-success">Busy <br/> Lifestyle</span>
    </h3>
    )
  }

    const sliderList = {
      title: "What Our <span>Students Say</span>",
      subtitle: "Real success stories from our learners",

      settings: {
        slidesPerView: 3,
        spaceBetween: 20,
        breakpoints: {
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        },
      },

      items: [
        {
          id: 1,
          name: "Ahmad Ali",
          location: "Adelaide, SA",
          description:
            "Highly recommended! I achieved my desired scores in NAATI CCL Urdu thanks to NAATI experts Ma’am Bushra and Gaza. Their guidance and support made a huge difference, and the practice material they provided was spot on. I’m really grateful for their help throughout my preparation.",
          image:
            "/images/web-new-images/new-content-slider/Ahmad-Ali.svg",
        },
        {
          id: 2,
          name: "Wasif Grumman",
          location: "Sydney, NSW",
          description:
            "Thank you for your guidance and support throughout my learning journey. Especially Sir Lokesh, Your teaching style is clear, patient, and very encouraging. I’ve gained confidence in my language skills because of your classes. I truly appreciate your dedication and effort.",
          image:
            "/images/web-new-images/new-content-slider/Wasif-Grumman.svg",
        },
        {
          id: 3,
          name: "Pritam Raha",
          location: "Sydney, NSW",
          description:
            "I took an online course at LA Academy as part of my NATTI preparation. I found the course valuable and useful. I would recommend everyone to give a try to LA before sitting the exam.",
          image:
            "/images/web-new-images/new-content-slider/Pritam.svg",
        },
        {
          id: 4,
          name: "S Antara",
          location: "Dhaka, Bangladesh",
          description:
            "I enrolled in NAATI Bangla coaching classes two months before my exam, and Tanushree Ma’am was my mentor. Her guidance was extremely helpful for my NAATI preparation. She focused on exam-oriented practice and effective note-taking techniques. Her constructive feedback helped me improve steadily and gain confidence.",
          image: "/images/web-new-images/new-content-slider/S-Antara.svg",
        },
        {
          id: 5,
          name: "Maham Naqvi",
          location: "Sydney, NSW",
          description:
            "I’ve had a great experience with LA Academy. The Urdu Naati team is incredibly devoted and genuinely committed to helping students succeed. They provide high-quality, best practice materials for both PTE and NAATI, which are really effective and easy to follow. Tutors teaching for Urdu Naati are extremely knowledgeable and helpful and do their best to make you prepare and excel in exams.",
          image:
            "/images/web-new-images/new-content-slider/Maham-Naqvi.svg",
        },
        {
          id: 6,
          name: "Karthik B Suresh",
          location: "Bavaria, Germany",
          description:
            "Thank you LA and Harshitha mam for your support and tips. I was able to clear the NAATI Kannada exam. Highly recommend.",
          image:
            "/images/web-new-images/new-content-slider/Karthik-B.svg",
        },

        {
          id: 7,
          name: "Mohd Amaan",
          location: "Hyderabad, India",
          description:
            "I studied NAATI at this language academy and it was a great experience. This institute genuinely cares about students rather than just grabbing money. Sumanti ma’am and Sakshi ma’am were amazing mentors and supported me at every step. If they tell you that you’re ready for the exam, trust me — you will pass. Highly recommended!",
          image:
            "/images/web-new-images/new-content-slider/Mohd-Amaan.svg",
        },

        {
          id: 8,
          name: "Mukesh Kumar",
          location: "-",
          description:
            "I’m really thankful to LA and Isaac sir for their constant support and guidance throughout my NAATI CCL Tamil preparation. The practice portal, updated materials, and regular feedback sessions made a huge difference for me. Even though I couldn’t do separate study, the structured practice and corrections helped me build confidence and improve steadily. Thanks a lot to the entire LA team and Isaac sir for helping me clear the test in my first attempt! Highly recommended for anyone preparing for NAATI!",
          image:
            "/images/web-new-images/new-content-slider/Mukesh-Kumar.svg",
        },

        {
          id: 9,
          name: "Ela",
          location: "Chennai, India",
          description:
            "I had taken the NAATI Tamil sessions for a month over here. The tutor Isaac was extremely polite and fluent and helped me understand and score well in the test. I was able to pass the test under his guidance. Though LA provided me with a portal to practice the test and also learn the meanings, attending the live sessions was good enough for me. I highly recommend LA for the NAATI test preparation",
          image:
            "/images/web-new-images/new-content-slider/Ela.png",
        },

        {
          id: 10,
          name: "Shreya Mirza",
          location: "Dhaka, Bangladesh",
          description:
            "I’m absolutely delighted to share that I’ve successfully passed my NAATI CCL Bangla exam, and I owe a huge part of this achievement to Language Academy. The online classes were exceptionally well-structured, comprehensive, and focused on real exam scenarios, which made preparation much smoother and more effective. A special thanks to Tanusree ma’am, whose expert guidance, patience, and encouragement were truly invaluable throughout my journey. Her detailed feedback after every practice session helped me identify my weak areas and steadily improve my interpretation skills. The mock tests and vocabulary sessions she conducted closely mirrored the actual exam format, which boosted my confidence immensely. I highly recommend Language Academy and Tanusree ma’am to anyone preparing for the NAATI CCL exam — their teaching quality and support are second to none!",
          image:
            "/images/web-new-images/new-content-slider/Shreya-Mirza.svg",
        },

        {
          id: 11,
          name: "Mehak Kapoor",
          location: "Sydney, NSW",
          description:
            "The teachers at LA Academy deserve my heartfelt thanks for their invaluable support and guidance during my NAATI Hindi and PTE 8 each exam preparation. Their encouragement and dedication played a significant role in my success, and I appreciate everything they've done for me.",
          image:
            "/images/web-new-images/new-content-slider/Mehak-Kapoor.svg",
        },

        {
          id: 12,
          name: "Anannya Khera",
          location: "Melbourne, VIC",
          description:
            "I’m very thankful to Language Academy and especially Aman Sir and Avneet Ma'am for their excellent support in helping me score 78/90 in the NAATI Punjabi test. The classes were focused and practical, with great tips and regular mock tests that really boosted my confidence. Highly recommended for anyone preparing for NAATI!",
          image:
            "/images/web-new-images/new-content-slider/Anannya-Khera.svg",
        },

        {
          id: 13,
          name: "Sanam Patel",
          location: "Bareja, Gujarat, India",
          description:
            "I would like to express my heartfelt gratitude to all the teachers at LA Academy for their unwavering support and guidance throughout my NAATI exam preparation. Your dedication and encouragement played a crucial role in helping me succeed. Thank you so much!.",
          image:
            "/images/web-new-images/new-content-slider/Sanam-Patel.svg",
        },

        {
          id: 14,
          name: "Jaspreet Singh",
          location: "-",
          description:
            "Hi team, Thank you for providing the much needed guidance for NAATI CCL Punjabi language exam. Special thanks to Aman sir for his useful tips and for providing suggestions to improve my performance.",
          image:
            "/images/web-new-images/new-content-slider/Jaspreet-Singh.svg",
        }
      ],
    };

  const featureData = {
    title: "More Than Apps, They’re Your",
    highlightText: "Success Companions",
    bottomText: "This isn't just practice, it's precision preparation.",
    ctaText: "Start Your Precision Preparation",
    onCtaClick: `${import.meta.env.VITE_NAATI_URL}auth/register`,
    cards: [
      {
        icon: Seamless,
        title: "Seamless Integration",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description:
          "Works perfectly alongside our online classes and in-person coaching. Your progress syncs across all platforms for both NAATI CCL preparation.",
      },
      {
        icon: Smart,
        title: "Smart Progress Tracking",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description:
          "Monitor your improvement across all vocabulary categories, dialogue types. See exactly where you need to focus for each exam.",
      },
      {
        icon: Expert,
        title: "Expert-Designed Content",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description: "Every feature, dialogue, vocabulary list, and the template is crafted by certified professionals who understand both exams inside out.",
      },
      {
        icon: Regular,
        title: "Regular Updates",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description: "Content is continuously updated based on recent exam patterns and feedback from successful students for NAATI CCL",
      },
    ],
  };

  return (
      <React.Fragment>
        <Helmet>
          <title>NAATI App: Best NAATI CCL Practice App for Exam Preparation</title>
          <meta
            name="description"
            content="Boost your NAATI CCL preparation with our NAATI App. Practice real exam dialogues, mock tests, vocabulary, and AI-based learning anytime, anywhere."
          />
          <meta name="twitter:title" content="NAATI App: Best NAATI CCL Practice App for Exam Preparation" />
          <meta property="og:title" content="NAATI App: Best NAATI CCL Practice App for Exam Preparation" />
        </Helmet>
        <Header />
        <main className="new-design">

        <div className="banner-section mt-0 noc-banner pt-0">
          <section className="naati-hero-section pt-5 d-none" style={{'--background-color':'radial-gradient(circle at center,#7F56D9E0 0%,#182A4F 45%,#182A4F 100%)','--text-color':'white'}}>
            {/* container-fluid px-3 px-md-4 px-lg-5 hero-container */}
            <div className="custom-container py-5">
              <div className="row align-items-center g-5">

                {/* Left side - Text + Stats */}
                <div className="col-lg-6 text-center text-lg-start">
                  <div className="students-stat mb-4">
                    <span className="FS18FW400 fw-600">50,000+ Students Dreams Turned into Success</span>
                  </div>

                  <p className="top-section-text FS56FW500 mb-4">
                    Master <span className="text-success">NAATI CCL</span> From<br />
                    Anywhere With Best NAATI<br />
                    CCL Exam Practice App
                  </p>

                  <p className="lead-text FS20FW500 mb-4">
                    The complete mobile solution that ensures your language proficiency goals<br />
                    are always within reach, wherever life takes you.
                  </p>

                  <div className="join-community d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
                    <div className="avatars d-flex">
                      <img src="/images/web-new-images/emojis/Updated/followers1.jpg" alt="user" className="avatar rounded-circle" />
                      <img src="/images/web-new-images/emojis/Updated/followers2.jpg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/emojis/Updated/followers3.jpg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/emojis/Updated/followers4.jpg" alt="user" className="avatar rounded-circle ms-n3" />
                    </div>
                    <span className="join-text FS20FW500 fw-600">Join 2M+ Students</span>
                  </div>
                  {/* <div className="iframe-video-outer position-relative">
                    <img
                      className="emoji2 position-absolute"
                      src="/images/web-new-images/emojis/Updated/emoji-rocket.png"
                      alt="LA"
                    />
                    <img
                      className="emoji4 position-absolute"
                      src="/images/web-new-images/emojis/Updated/emoji-cup.png"
                      alt="LA"
                    />
                  </div> */}
                </div>

                {/* Right side - Phones mockup */}
                <div className="col-lg-6">
                  <div className="phones-container position-relative text-center">
                    <img
                      src="/images/web-new-images/emojis/Updated/new-iphone-dashboard.webp"
                      alt="NAATI CCL App - Mock Test"
                      className="img-fluid"
                    />
                  </div>
                </div>

              </div>
            </div>
          </section>
          <HeroSectionUpdated data={heroData} />
          {/* Download Section */}
          <section className="download-section custom-container" style={{'--background-color':'#fff','--text-color':'#000'}}>
          <div className="download-container py-5">
            <div className="row align-items-center">

              {/* Left Content */}
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h2 className="top-section-text FS40FW600 fw-600">
                  Download Our <span className="text-success FS40FW600">NAATI CCL App</span> Today!
                </h2>

                <p className="subtitle FS17FW500">
                  Achieve your Australian permanent residency dreams and global
                  opportunities with our powerful mobile apps, designed specifically
                  for busy professionals, students, and immigrants who need
                  flexible, expert-level preparation for NAATI CCL exams.
                </p>

                {/* <button className="primary-btn" onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)}>
                  Download Our App Today <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                </button> */}
                <div>
                <ButtonComp className="mt-4" link={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)} btnText={"Download Our App Today"} img="/images/web-new-images/new-dark-arrow.svg"/>
                </div>
              </div>

              {/* Right Cards */}
              <div className="col-lg-6">
                <div className="row g-4">

                  {/* iOS Card */}
                  <div className="col-md-6">
                    <div className="download-card FS40FW600" style={{'--background-color':'#F2F2FF','--text-color':'#0D1830'}}>
                      <p>
                        For <span>iOS</span>
                      </p>
                      {/* <p className="subtitle FS16FW500" style={{'--text-color':'#383838'}}>iOS 26.3</p> */}

                      {/* <button className="primary-btn"  onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)}>
                        Download Now <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                      </button> */}
                      <ButtonComp className="mt-2" link={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)} btnText={"Download Now"} img="/images/web-new-images/new-dark-arrow.svg"/>

                      <div className="card-footer d-flex justify-content-between align-items-center mt-4">
                        {import.meta.env.VITE_NAATI_IOS_APP_URL ? 
                        <QRCode value={`${import.meta.env.VITE_NAATI_IOS_APP_URL}`} className="qr"/> :
                        <img src="/images/web-new-images/emojis/Updated/sample-qr.svg" alt="QR" className="qr" />
                      }

                        <div className="circle-wrapper" style={{'--background-color':'#fff'}}>
                        <div className="circle-inner" style={{'--background-color':'#dcdcdc'}}>
                          <img src="/images/web-new-images/emojis/Updated/apple-logo-icon.png" alt="IOS" className="device-icon" />
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>

                  {/* Android Card */}
                  <div className="col-md-6">
                    <div className="download-card FS40FW600" style={{'--background-color':'#F2F2FF','--text-color':'#0D1830'}}>
                      <p>
                        For <span>Android</span>
                      </p>
                      {/* <p className="subtitle FS16FW500" style={{'--text-color':'#383838'}}>Android 16</p> */}

                      {/* <button className="primary-btn" onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_ANDROID_APP_URL)}>
                        Download Now <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                      </button> */}
                    <ButtonComp className="mt-2" link={() => openExternalUrl(import.meta.env.VITE_NAATI_ANDROID_APP_URL)} btnText={"Download Now"} img="/images/web-new-images/new-dark-arrow.svg"/>  

                      <div className="card-footer d-flex justify-content-between align-items-center mt-4">
                        {import.meta.env.VITE_NAATI_ANDROID_APP_URL ?
                        <QRCode value={`${import.meta.env.VITE_NAATI_ANDROID_APP_URL}`} className="qr"/> :
                        <img src="/images/web-new-images/emojis/Updated/sample-qr.svg" alt="QR" className="qr" />
                      }

                        <div className="circle-wrapper" style={{'--background-color':'#fff'}}>
                        <div className="circle-inner" style={{'--background-color':'#dcdcdc'}}>
                         <img src="/images/web-new-images/emojis/Updated/android-icon.png" alt="Android" className="device-icon" />
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>
          <div className="card-wrapper">
            <ReusableHomePageSlider images={images} />
          </div>
        </div>
        {/* Old code */}
        
        <div className="custom-container success-section py-5">
          <div className="align-items-center justify-content-between row">
            
            {/* LEFT CONTENT */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h1 className="hero-title FS40FW600">
                How Language Academy <span className="text-success">Apps</span>
                <br />
                <span className="text-success">Increase</span> Chances For Success
              </h1>

              <div className="quote-box FS18FW400 mt-3">
                Missing classes due to work commitments? Stuck in traffic during your
                commute? Have a few spare minutes between meetings?
              </div>

              <p className="mt-3 FS17FW500 fw-400">
                Your NAATI CCL preparation never has to stop.
              </p>

              <p className="FS17FW500 fw-400">
                Our mobile apps deliver the same expert-level training that has helped
                50,000+ students achieve their goals, now optimized for your smartphone
                and available 24/7.
              </p>

              {/* <button className="primary-btn mt-3" onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)}>
                Start Your Mobile Mastery <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
              </button> */}
              <ButtonComp className="mt-5" link={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)} btnText={"Start Your Mobile Mastery"} img="/images/web-new-images/new-dark-arrow.svg"/>  
            </div>

            {/* RIGHT IMAGE SECTION */}
            <div className="col-lg-6">
                <img
                  src="/images/web-new-images/emojis/Updated/AppSuccess1.webp"
                  alt="mobile1"
                />
            </div>
          </div>
        </div>
        
        <div className="pc-why-choose np-need-crack">
          <div className="custom-container">
          <section className="academy-section py-5">
            <div className="custom-container">
              <div className="hero-title FS40FW600 text-center mb-5">
                Everything You Need {" "}
                <span className="text-success">
                  To Crack NAATI <br></br> CCL
                </span>
                {" "}In Your Pocket
              </div>

              {academySections.map((section, index) => {
                const imageLeft = index % 2 === 0;
                return (
                  <div
                    className="row align-items-center mb-5 gap-5"
                    key={index}
                  >
                    <div
                      className={`col-lg-${imageLeft ? 6 : 5} col-md-12 mb-4 mb-lg-0 ${
                        imageLeft ? "" : "order-lg-2"
                      }`}
                    >
                      <div className="academy-app-preview text-center">
                        <img
                          src={section.imageSrc}
                          className="img-fluid"
                          alt="app preview"
                        />
                      </div>
                    </div>
                    <div
                      className={`col-lg-${imageLeft ? 5 : 6} col-md-12 ${
                        imageLeft ? "" : "order-lg-1"
                      }`}
                    >
                      <div
                        className="academy-sound-icon"
                        style={{ background: section.iconBg }}
                      >{section.icon}</div>

                      <h3 className="academy-subtitle">{section.title}</h3>

                      <div className="academy-highlight-box FS16FW500 mt-3 mb-4 fw-700">{section.highlight}</div>

                      <ul className="feature-list">
                        {section.features.map((feature, i) => (
                          <li key={i} className="FS18FW400">{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="d-flex justify-content-center">
              {/* <button className="primary-btn" onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)}>Experience The Full Power Of Mobile Learning</button> */}
              <ButtonComp link={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)} btnText={"Experience The Full Power Of Mobile Learning"} img="/images/web-new-images/new-dark-arrow.svg"/>
            </div>
          </section>
          </div>
        </div>
        <SkillAreas 
         skillAreaTitle={skillAreaTitle} 
         lifestyleCards={lifestyleCards} 
         leftSection={false}
         className={"text-center d-flex flex-column align-items-center justify-content-center"}
         skillBottomtitle={"Your schedule doesn't have to limit your success."}
         btnText2={"Get Instant Access"}
         btnLink2={`${import.meta.env.VITE_NAATI_URL}auth/register`}
        />

        <div className="master-aspect-section ap-minute-count mt-5">
          <div className="custom-container">
            <div className="row">
              <h2 className="hero-title FS40FW600 text-center">
                The {" "}
                <span className="text-success FS40FW600">
                5-Point Difference
                & Global Opportunities:
                </span>
                <br />
                  Why Every Minute Counts
              </h2>
              <div className="master-cards">
                <div className="master-card">
                  <h2 className="card-title"><span className="top-section FS24FW500 fw-700">NAATI CCL</span> <br /><span className="FS20FW500"> The stakes are high</span></h2>
                  <ul className="feature-list">
                    <li className="FS18FW400">
                      <p>5 bonus points can move you from "not competitive" to "invitation received"</p>
                    </li>
                    <li className="FS18FW400">
                      <p>Thousands of applications depend on these critical points</p>
                    </li>
                    <li className="FS18FW400">
                      <p>Your Australian dream shouldn't be left to chance</p>
                    </li>
                  </ul>
                </div>
                <div className="master-card card2">
                  <h2 className="card-title"><span className="top-section FS24FW500 fw-700">Preparation Time</span> <br /><span className="FS20FW500"> Maximize Your Potential</span></h2>
                  <ul className="feature-list">
                    <li className="FS18FW400">
                      <p>Every minute matters when preparing for such important exams</p>
                    </li>
                    <li className="FS18FW400">
                      <p>Consistent daily practice beats intensive cramming sessions</p>
                    </li>
                    <li className="FS18FW400">
                      <p>Mobile accessibility means no wasted opportunities</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center">
                <p className="sub-heading m-0">
                  Don't let a busy schedule cost you your future opportunities.
                </p>
                {/* <Link to="/auth/register" className="primary-btn">
                  Secure Your Success Today
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link> */}
                <ButtonComp className="mt-80" link={`${import.meta.env.VITE_NAATI_URL}auth/register`} btnText={"Secure Your Success Today"} img="/images/web-new-images/new-dark-arrow.svg"/>
              </div>
            </div>
          </div>
        </div>

        <div className="all-language-section language-support">
          <div className="custom-container">
            <div className="row">
              <h2 className="hero-title FS40FW600 text-center mb-md-0">
                Comprehensive {" "}<span className="text-success FS40FW600">
                  Language Support
                </span>
              </h2>
            </div>        
            <div className="all-language-content">
              <div className="all-lang-cards">
                <h2 className="title text-center FS24FW500">
                  NAATI CCL preparation available in all 12 languages
                </h2>

                <div className="lang-grid">
                  {[
                    { native: "हिंदी", name: "Hindi" },
                    { native: "पंजाबी", name: "Punjabi" },
                    { native: "اردو", name: "Urdu" },
                    { native: "नेपाली", name: "Nepali" },
                    { native: "বাংলা", name: "Bangla" },
                    { native: "தமிழ்", name: "Tamil" },
                    { native: "తెలుగు", name: "Telugu" },
                    { native: "മലയാളം", name: "Malayalam" },
                    { native: "ગુજરાતી", name: "Gujarati" },
                    { native: "सिंहली", name: "Sinhalese" },
                    { native: "मराठी", name: "Marathi" },
                    { native: "ಕನ್ನಡ", name: "Kannada" },
                  ].map((lang, index) => (
                    <div className="d-flex flex-column justify-content-center lang-card" key={index}>
                      <span className="native FS16FW500">{lang.native}</span>
                      <h3 className="FS20FW500 mb-0">{lang.name}</h3>
                    </div>
                  ))}
                </div>
              </div>
              {/* <div className="all-lang-card">
                <h2 className="title">PTE PREPARATION FOR GLOBAL SUCCESS</h2>
                <p>
                  Complete preparation materials for PTE Academic and PTE Core, accepted by institutions and immigration authorities worldwide.
                  <br />
                  <br />
                  Complete vocabulary translations, cultural context, and practice materials in your native language for NAATI CCL, plus comprehensive PTE preparation for international opportunities.
                </p>
              </div> */}
            </div>        
            <div className="text-center">
              {/* <Link to="/auth/register" className="primary-btn dark-border">
                Find Your Preparation Path
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link> */}
              <ButtonComp link={`${import.meta.env.VITE_NAATI_URL}auth/register`} btnText={"Find Your Preparation Path"} img="/images/web-new-images/new-dark-arrow.svg"/>
            </div>
          </div>
        </div>

         <div className="sss-section">
          <TestimonialSection
            title={`<span class="hero-title FS40FW600 text-center mb-0">What Our App <br/> <span class="green-text">Users Says</span></span>`}
            btnText="Join 50,000+ of Successful App Users"
            btnLink={import.meta.env.VITE_NAATI_IOS_APP_URL}
            sliderList={sliderList}
            titleClass="text-start"
            showBtn={true}
            extraClass={"flex-column flex-lg-row flex-lg-row text-start"}
            extraWidth={"700px"}
          />
        </div>

          <FeatureSection {...featureData} />
        <div className="bottom-line-section">
          <div className="custom-container">
            <div className="row align-items-center">

              {/* LEFT IMAGE */}
              <div className="col-lg-6">
                <div className="">
                  <img
                    src="/images/web-new-images/emojis/Updated/Naati-App-banner.png"
                    alt="app preview"
                    className=""
                  />
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-6">
                <div className="content-wrapper">

                  <h2 className="hero-title FS40FW600 mb-4">
                    The Bottom Line:{" "}
                    <span className="text-success FS40FW600">Your Success is Mobile</span>
                  </h2>
                  <div className="quote-box FS18FW400 mb-4">
                    <p>
                      Cracking NAATI CCL isn't rocket science, but it does require smart,
                      consistent preparation.
                    </p>
                  </div>

                  <p className="desc">
                    We understand the life-changing value of those 5 NAATI CCL points for Australian permanent residency and the global opportunities. That's why we've created the most comprehensive, convenient, and effective language exam preparation apps available.
                  </p>

                  <p className="desc">
                    Your dreams deserve expert preparation, now available wherever you are.
                  </p>

                  {/* LIST */}
                  <ul className="feature-list">
                    <li>Busy schedule? Practice on your commute</li>
                    <li>Missed a class? Access the same materials instantly</li>
                    <li>Need quick review? Everything's in your pocket</li>
                    <li>Multiple exams to prepare for? Switch between NAATI CCL seamlessly</li>
                    <li>Exam tomorrow? Last-minute packages have you covered</li>
                  </ul>

                  {/* BUTTON */}
                  <div className="btn-wrapper">
                    {/* <button className="primary-btn" onClick={() => openExternalUrl(import.meta.env.VITE_NAATI_ANDROID_APP_URL)}>
                      Download Now And Transform Your Commute Into Exam Success <img
                              src="/images/web-new-images/right-arrow.svg"
                              alt="Register Now"
                            />
                    </button> */}
                    <ButtonComp className="mt-5" link={() => openExternalUrl(import.meta.env.VITE_NAATI_IOS_APP_URL)} btnText={"Download Now And Transform Your Commute Into Exam Success"} img="/images/web-new-images/new-dark-arrow.svg"/>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

         <section className="naati-hero-section bottom-section-radius custom-container">
            <div className="px-3 px-md-4 px-lg-5 hero-container py-5">
              <div className="row align-items-center g-5">

                {/* Left side - Text + Stats */}
                <div className="col-lg-6 text-center text-lg-start">

                  <p className="top-section-text FS56FW500 mb-4">
                    Ready To Secure <span className="text-success FS56FW500">Your Success</span>
                  </p>

                  <p className="lead-text FS20FW500 mb-4">
                    Don't let a busy lifestyle delay your Australian permanent residency dreams or global opportunities.
                  </p>
                  <p className="lead-text FS20FW500 mb-4">
                    Download the Language Academy apps today and Join 50K+ of successful students' who've earned their goals through smart, flexible preparation.
                  </p>

                  <div className="download-buttons mb-5 d-flex flex-wrap justify-content-center justify-content-lg-start gap-3">
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_NAATI_ANDROID_APP_URL}>
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_NAATI_IOS_APP_URL}>
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  </div>

                  <div className="join-community d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
                    <div className="avatars d-flex">
                      <img src="/images/web-new-images/new-content-slider/User-01.svg" alt="user" className="avatar rounded-circle" />
                      <img src="/images/web-new-images/new-content-slider/Pritam.svg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/new-content-slider/Karthik-B.svg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/new-content-slider/RamimRahman-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
                      <img src="/images/web-new-images/new-content-slider/SapnaPandey-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
                    </div>
                    <span className="join-text FS20FW500 fw-600">Join 50K+ Students'</span>
                  </div>
                </div>

                {/* Right side - Phones mockup */}
                <div className="col-lg-6">
                  <div className="phones-container position-relative text-center">
                    <img
                      src="/images/web-new-images/emojis/Updated/new-iphone-dashboard.webp"
                      alt="NAATI CCL App - Mock Test"
                      className="img-fluid"
                    />
                  </div>
                </div>

              </div>
            </div>
          </section>

        </main>
        <Footer />
      </React.Fragment>
    );
};

export default NaatiAppNew;